import { render, staticRenderFns } from "./VirtualOffice.vue?vue&type=template&id=381b9406&scoped=true"
import script from "./VirtualOffice.vue?vue&type=script&lang=js"
export * from "./VirtualOffice.vue?vue&type=script&lang=js"
import style0 from "./VirtualOffice.vue?vue&type=style&index=0&id=381b9406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b9406",
  null
  
)

export default component.exports